/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoGameSmall = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'string',
            isRequired: true,
        },
        description: {
            type: 'string',
            isRequired: true,
        },
        shareKey: {
            type: 'string',
            isRequired: true,
        },
        league: {
            type: 'LeagueListElement',
            isRequired: true,
        },
    },
} as const;
